<h1 mat-dialog-title *ngIf="!atWelcome" i18n>First Steps</h1>
<div mat-dialog-content>
  <div *ngIf="atWelcome">
    <!-- <div class="languageOptions">
      <mat-form-field>
        <mat-select
          value="{{ _session.getCurrentLocale() }}"
          placeholder="Language (Sprache)"
          #languageSelect
          (selectionChange)="changeLanguageVersion(languageSelect.value)"
        >
          <mat-option value="de">German (Deutsch)</mat-option>
          <mat-option value="en">English (Englisch)</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <h1 class="greeting" i18n>
      <span class="toolNameSpan">Welcome</span> to the Text convOERter using Generative AI!
    </h1>
    <img
      class="logo"
      src="assets/oer-logo-4.png"
      height="130"
      width="130"
      alt="Logo"
    />
    <p class="welcomeText" i18n>
      This web app allows you to easily generate text via existing documents into Open Educational Resources (OER) or to ask the AI to generate a new text.
    </p>
    <div class="oerInfos">
      <a
        href="https://creativecommons.org/about/program-areas/education-oer/"
        target="_blank"
        i18n
        i18n-href
        >What is OER?</a
      >
    </div>

    <mat-list style="margin-top: 0; padding-top: 0">
      <h2 style="margin-bottom: 0; margin-top: 0.8rem" i18n>How it works</h2>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>question_answer</mat-icon>
        <div mat-line i18n>General Query</div>
        <div class="allowWrap" mat-line i18n>
          Ask any question or provide any prompt to get real-time AI assistance. Perfect for factual information, creative writing, problem-solving, or generating structured content.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>description</mat-icon>
        <div mat-line i18n>Document Analysis</div>
        <div class="allowWrap" mat-line i18n>
          Upload documents (PDF, DOC, DOCX) and ask specific questions about them. The AI will analyze the content and provide insights, summaries, key points, and more.
        </div>
      </mat-list-item>
     <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>lock</mat-icon>
        <div mat-line i18n>Local Processing</div>
        <div class="allowWrap" mat-line i18n>
          Your document is modified locally and not
          sent to any external server.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>auto_awesome</mat-icon>
        <div mat-line i18n>Smart Formatting</div>
        <div class="allowWrap" mat-line i18n>
          All AI responses are smartly formatted with proper tables, bullet points, and text styling for easy reading and copying into your documents.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>content_copy</mat-icon>
        <div mat-line i18n>Copy & Edit</div>
        <div class="allowWrap" mat-line i18n>
          Easily copy generated content with formatting preserved, edit your questions, and maintain a conversation history throughout your session.
        </div>
      </mat-list-item>
    </mat-list>

    <mark i18n
      >Please note that you have to either be the copyright owner or have
      permission from all copyright owners of all content to publish
      it as OER.</mark
    >
    <p i18n>
      When you are ready, you can start with the text module.
    </p>
    <div>
      <button
        mat-raised-button
        color="primary"
        (click)="startModule()"
        #startButton
        cdkFocusInitial
      >
        Start!
      </button>
    </div>
  </div>

  <mat-horizontal-stepper
    #stepper
    linear
    *ngIf="!atWelcome"
    labelPosition="bottom"
    [formGroup]="stepperFormGroup"
    (selectionChange)="onStepChange($event)"
  >
    <mat-step
      label="Choose Document"
      i18n-label
      state="chooseFile"
      [stepControl]="stepperFormGroup.get('chosenFile')"
    >
      <h3 i18n>Select the text document you want to convert into an OER</h3>
      <h5 i18n>Supported formats are {{ getAllTextFormats() }}.</h5>
      <app-import-file (file-import)="onFileImport($event)"></app-import-file>
      <br /><br />
      <div>
        <button
          [disabled]="!stepperFormGroup.get('chosenFile').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      label="Enter Name"
      i18n-label
      state="enterUserName"
      [stepControl]="stepperFormGroup.get('userName')"
    >
      <h3 i18n>Enter your name</h3>
      <h5 i18n>
        This name will be included in the resulting license disclaimer.
      </h5>
      <mat-form-field (keydown.enter)="stepper.next()">
        <mat-label i18n>Your full name</mat-label>
        <input
          matInput
          i18n-placeholder
          placeholder="John Doe"
          formControlName="userName"
        />
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('userName').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      i18n-label
      label="Enter Target License"
      state="enterTargetLicense"
      [stepControl]="stepperFormGroup.get('targetLicense')"
    >
      <h3 i18n>Choose a license for the resulting OER</h3>
      <h5 i18n>
        For general information about open licenses visit
        <a href="https://creativecommons.org/" target="_blank"
          >creativecommons.org</a
        >
      </h5>

      <mat-form-field style="width: 100%">
        <mat-label i18n>Choose the targeted license</mat-label>
        <mat-select formControlName="targetLicense" required>
          <mat-option *ngFor="let license of licenses" [value]="license">
            {{ getLicenseShortName(license) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br />

      <div *ngIf="stepperFormGroup.get('targetLicense').value">
        <span i18n>Full name: </span>
        <i>{{
          getLicenseFullName(stepperFormGroup.get("targetLicense").value)
        }}</i>
        <br />
        <a
          [href]="getLicenseURL(stepperFormGroup.get('targetLicense').value)"
          target="_blank"
          i18n
          >More Info about this license</a
        >
      </div>
      <br />
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('targetLicense').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      label="Enter Legal Disclaimer"
      i18n-label
      state="enterLegalText"
      [stepControl]="stepperFormGroup.get('disclaimerSlideText')"
    >
      <h3 i18n>Edit the generated disclaimer</h3>
      <h5>
        <span i18n>This disclaimer will be included in the resulting OER.</span>
        <br />
        <span i18n>You can edit it to your liking.</span>
      </h5>
      <mat-form-field style="width: 100%">
        <mat-label i18n>Disclaimer Text</mat-label>
        <textarea
          matInput
          rows="5"
          i18n-placeholder
          placeholder="Please enter the text on the legal disclaimer slide"
          formControlName="disclaimerSlideText"
          style="height: auto"
        ></textarea>
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button mat-stroked-button color="primary" matStepperNext i18n>
          Next
        </button>
      </div>
    </mat-step>

    <mat-step label="Additional Options" i18n-label state="additionalOptions">
      <h3 i18n>Additional Options</h3>
      <h5 i18n>
        This feature helps analyze text content to suggest replacement options and citations automatically.
      </h5>
      <br />
      <mat-slide-toggle #autoClassifyToggle
        ><h4 i18n>Auto-analyze content</h4></mat-slide-toggle
      >
      <p *ngIf="autoClassifyToggle.checked" class="toggleDescText" i18n>
        If you select text content and choose to search for a replacement, the tool
        will automatically analyze the content and suggest similar Creative Commons licensed alternatives.
      </p>
      <p *ngIf="!autoClassifyToggle.checked" class="toggleDescText" i18n>
        The tool will not automatically analyze or suggest alternatives when
        you choose to search for replacement text content.
      </p>
      <br />
      <button mat-button matStepperPrevious i18n>Back</button>
      <button
        mat-button
        mat-raised-button
        color="primary"
        (click)="processAdditionalOptions(autoClassifyToggle.checked)"
        i18n
      >
        Finish
      </button>
    </mat-step>

    <ng-template matStepperIcon="chooseFile">
      <mat-icon>description</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterUserName">
      <mat-icon>person</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterTargetLicense">
      <mat-icon>gavel</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterLegalText">
      <mat-icon>assignment_late</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="additionalOptions">
      <mat-icon>settings</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>
</div> 